import React, { useState, useMemo } from 'react';
import {
  Box,
  Card,
  CardContent,
  Container,
  Link,
  Grid,
  Tab,
  Tabs,
  TextField,
  Typography,
} from '@mui/material';
import { Icon } from '@iconify/react';
import searchFill from '@iconify/icons-eva/search-fill';
import { useList } from 'src/hooks/useFetch.hook';
import { Loader } from '../Loader';
import arrowIosForwardFill from '@iconify/icons-eva/arrow-ios-forward-fill';

export default function ZynkaStuite() {
  const [selectedTab, setSelectedTab] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const { data: productList = [], isFetching } = useList("getComapnyProductCatalog");

  const categories = useMemo(() => {
    const unique = [...new Set(productList.map(p => p.category))];
    return ['All Products', ...unique];
  }, [productList]);

  const filteredProducts = useMemo(() => {
    return productList.filter((product) => {
      const matchesTab =
        selectedTab === 0 || product.category === categories[selectedTab];
      const matchesSearch = product.title
        .toLowerCase()
        .includes(searchTerm.toLowerCase());
      return matchesTab && matchesSearch;
    });
  }, [productList, selectedTab, searchTerm, categories]);

  if (isFetching) return <Loader />;

  return (
    <Card sx={{ p: 2 }}>
      <Box sx={{ minHeight: '100vh', py: 2 }}>
        <Container maxWidth="lg">
          <Typography variant="h4" gutterBottom fontWeight="bold" mb={3}>
            Products Catalog
          </Typography>

          <Tabs
            value={selectedTab}
            onChange={(e, val) => setSelectedTab(val)}
            textColor="inherit"
            indicatorColor="primary"
            variant="scrollable"
            scrollButtons="auto"
            sx={{ mb: 3 }}
          >
            {categories.map((cat, idx) => (
              <Tab key={idx} label={cat} />
            ))}
          </Tabs>

          <Box mb={3}>
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Search products..."
              size="small"
              InputProps={{
                startAdornment: (
                  <Icon icon={searchFill} style={{ marginRight: 8, color: '#94a3b8' }} />
                ),
                style: { borderRadius: 6 },
              }}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Box>

          <Grid container spacing={3}>
            {filteredProducts.map((product, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Card 
                  sx={{
                    borderRadius: 2,
                    minHeight: 140,
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                    '&:hover': {
                      transform: 'scale(1.03) translateY(-4px)',
                      boxShadow: 6, // MUI box shadow level
                      cursor: 'pointer'
                    },
                  }}
                >
                  <CardContent>
                    <Grid container alignItems="center" justifyContent="center" mb={2}>
                        <Grid item xs={2} sx={{ display: 'flex', justifyContent: 'center' }}>
                            <img
                                src={product.icon}
                                alt="icon"
                                style={{ 
                                    width: 30, 
                                    height: 30, 
                                    objectFit: 'contain', 
                                    borderRadius: 4, 
                                    padding: 4,
                                }}
                            />
                        </Grid>
                        <Grid item xs={10}>
                            <Typography variant="h6" fontWeight="bold">
                            {product.title}
                            </Typography>
                        </Grid>
                    </Grid>

                    <Typography variant="body2" color="#6f7172" gutterBottom>
                      {product.description}
                    </Typography>
                    {product.access_type === 1 ? (
                    <Link
                        href={product.url}
                        target="_blank"
                        underline="none"
                        color="success.main"
                        display="flex"
                        alignItems="center"
                        fontWeight="medium"
                        fontSize="0.875rem"
                        sx={{ mt: 2 }}
                    >
                        Access Now
                        <Icon
                        icon={arrowIosForwardFill}
                        style={{ marginLeft: 4, fontSize: '1rem' }}
                        />
                    </Link>
                    ) : (
                    <Box
                        display="flex"
                        alignItems="center"
                        color={
                        product.access_type === 2
                            ? 'error.main'
                            : 'warning.main'
                        }
                        fontWeight="medium"
                        fontSize="0.875rem"
                        sx={{ mt: 2 }}
                    >
                        {product.access_type === 0 ? 'Coming Soon' : 'Access Denied'}
                    </Box>
                    )}
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </Card>
  );
}
